/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ElectricalSettingsObject {
    result: ElectricalSettingsShortcuts;
}
export class ElectricalSettingsShortcuts {
    shortcutsKeyOne: string[];
    shortcutsKeyTwo: string[];
    shortcutsKeyThree: string[];
}